import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=3da30bf0&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style1 from "./edit.vue?vue&type=style&index=1&id=3da30bf0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da30bf0",
  null
  
)

export default component.exports